import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../shared/icons';
import MyButton from '../../../../UI/myButton/MyButton';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';
import { formatPrice } from '../../../../../../utils/FormatPrice';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleOpenDialogForm,
  handleOpenDokumenta,
  isLoading,
  naplacujeSe,
}) => {
  const shouldHideColumns = localStorage.sa === 'true';
  const allColumns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          handleOpenDokumenta={() => handleOpenDokumenta(e.row)}
          getEditData={() => handleOpenDialogForm(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'zaposleni', headerName: 'Zaposleni', width: 200 },
    { field: 'nazivUsluge', headerName: 'Vrsta', width: 200 },
    { field: 'jm', headerName: 'Jedinica mere', width: 120 },
    { field: 'kolicina', headerName: 'Količina', width: 80 },
    {
      field: 'praznik',
      headerName: 'Praznik',
      width: 80,
      renderCell: (params) => <span>{params.value ? 'DA' : 'NE'}</span>,
    },
    {
      field: 'brutoCenaTroskovi',
      headerName: 'Bruto cena zaposlenog',
      width: 200,
    },
    { field: 'cena', headerName: 'Cena prema klijentu', width: 200 },
    {
      field: 'cenaKolicina',
      headerName: 'Ukupno',
      width: 80,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold' }}>{formatPrice(params.value)}</span>
      ),
    },
    {
      field: 'datum',
      headerName: 'Datum',

      width: 150,
      renderCell: (e) => formatDateFromDB(e.row.datum),
    },
    { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];
  const columns = allColumns.filter((column) => {
    if (!shouldHideColumns) {
      // Sakrivamo kolone 'brutoCenaZaposlenog' i 'cena' kada je shouldHideColumns false
      if (
        column.field === 'brutoCenaTroskovi' ||
        column.field === 'cena' ||
        column.field === 'cenaKolicina'
      ) {
        return false;
      }
    }

    // Sakrivamo kolonu 'cena' ako naplacujeSe nije istinito, osim ako shouldHideColumns === true
    if (column.field === 'cena') {
      if (!naplacujeSe && !shouldHideColumns) {
        return false;
      }
      if (!naplacujeSe && shouldHideColumns) {
        return false;
      }
    }

    return true;
  });
  return (
    <div style={{ height: '45vh', width: '99%' }}>
      <MyButton
        label="Novi unos"
        style={{ marginBottom: '5px' }}
        onClick={() => handleOpenDialogForm({})}
      />
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleOpenDialogForm: PropTypes.func.isRequired,
};

export default GridProvider;
